import React, { useRef, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import Button from '../UI/Button'
import heroBottleImg from '../../assets/images/Hero-bottle.png'; 
import heroBgLogo from '../../assets/images/logo-lg.png';
import {gsap, ScrollTrigger} from 'gsap/all';
import SplitText from "../../utils/Split3.min"; 
import { timeToReadyTl } from '../../utils/gsapService'; 

gsap.registerPlugin(ScrollTrigger);

export default function Hero() {
     
    const HeroBottleWrap = useRef(null);
    const HeroBottle = useRef(null);
    const HeroBgLogo = useRef(null);
    const HeroWrap = useRef(null);
    const [readySection, setreadySection] = useState(false);


    useEffect(() => { 

        const MainBody = document.querySelector("#main-container");
        const SlideSection = document.querySelector(".horizontal-scroll-slide");
        const slideWrap = SlideSection.querySelector(".slide-wrapper");
        const firstSlide = SlideSection.querySelector(".slide-item-0");
        
        const slideHeading = firstSlide.querySelector(".text-content .title-md")
        const slideDes = firstSlide.querySelector(".text-content .des")
        const slideButton = firstSlide.querySelector(".text-content .btn-main")
        const firstSlideHeading = slideWrap.querySelector(".first-slide-item .title-lg");
        const HeroBottleDOM = ReactDOM.findDOMNode(HeroBottle.current);
        
        
        const HeroBottleClient = HeroBottleDOM.getBoundingClientRect()

        if(!MainBody.contains(document.querySelector(".hero-reference-bottle"))){
            const createHeroRefarencebottleEl = document.createElement('div');
            createHeroRefarencebottleEl.classList.add("hero-reference-bottle") 
            createHeroRefarencebottleEl.style.left = HeroBottleClient.x;
            createHeroRefarencebottleEl.innerHTML = HeroBottleDOM.innerHTML; 
            MainBody.appendChild(createHeroRefarencebottleEl);  
        }
        const heroReferenceBottle = document.querySelector(".hero-reference-bottle");

        gsap.set(heroReferenceBottle, {
            opacity:0
        })
 
        const setHeroRefBottle = setTimeout(() => {   
            const hbc = HeroBottleDOM.getBoundingClientRect();
            gsap.set(heroReferenceBottle, { 
                y:hbc.y,
                x:hbc.x,
                width:hbc.width,
                rotation:0
            });
            gsap.to(heroReferenceBottle, { 
                opacity:1
            });
            setreadySection(true); 
        }, 50);

        let bottleTl = null; 
        let slideBeginningTl = null; 

        const startTlAni = setTimeout(() => {

            // ScrollTrigger.refresh();

            const splitHeading = new SplitText([firstSlideHeading, slideHeading, slideDes], {
                type:"lines",
    
            });
            slideBeginningTl = gsap.timeline({paused:true});
            slideBeginningTl
            .to([splitHeading.lines,slideButton], {
                y:0,
                autoAlpha:1,
                duration:0.5,   
                stagger:0.1, 
                ease: "none.none"
            })
            gsap.set([splitHeading.lines,slideButton], {
                autoAlpha:0,
                y:30
            })   

            const SlideWrapClient = slideWrap.getBoundingClientRect(); 
            const SlideBottle = firstSlide.querySelector(".bottle .img-bottle"); 
            const SlideBottleClient = SlideBottle.getBoundingClientRect();

            gsap.set(SlideBottle, {
                opacity:0
            }); 

            bottleTl = gsap.timeline({
                scrollTrigger:{ 
                    trigger:HeroBottleWrap.current,
                    start:()=>{
                        return `top ${HeroBottleClient.y}`
                    },
                    end:()=>{
                        return `+=${(SlideWrapClient.y + SlideWrapClient.height / 1.5) - HeroBottleClient.y} 90%`
                    },
                    scrub:true, 
                    scroller:"#main-container", 
                    // markers:true, 
                    onLeave:()=>{  
                        console.log(SlideBottle.getBoundingClientRect());
                        slideBeginningTl.play();
                        gsap.set(SlideBottle, {
                            autoAlpha:1
                        })  
                        gsap.set(heroReferenceBottle, {
                            autoAlpha:0, 
                        }); 
                    },
                    onEnterBack:()=>{ 
                        slideBeginningTl.reverse();
                        gsap.set(SlideBottle, {
                            autoAlpha:0
                        })  
                        gsap.set(heroReferenceBottle, { 
                            autoAlpha:1
                        }); 
                    },
                }
            })
            bottleTl
            .to(heroReferenceBottle, { 
                y:SlideBottleClient.y/2,
                x:SlideBottleClient.x / 1, 
                rotation:25, 
                ease:"none",
                duration:0.5
            })
            .to(heroReferenceBottle, { 
                y:SlideBottleClient.y, 
                x:SlideBottleClient.x, 
                width:SlideBottleClient.width,
                rotation:0,
                ease:"none",
                duration:0.5
            }); 
            
            ScrollTrigger.refresh(); 
           
        }, timeToReadyTl.firstDelay); 

        return ()=>{
            clearTimeout(startTlAni);
            clearTimeout(setHeroRefBottle); 
            if(bottleTl != null) bottleTl.kill();
            if(slideBeginningTl != null) slideBeginningTl.kill();

            MainBody.removeChild(document.querySelector(".hero-reference-bottle")); 
            ScrollTrigger.refresh();
        }

    }, [readySection]);
    return ( 
        <section className="hero-area bg-body" ref={HeroWrap}> 
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 d-flex align-items-center">
                        <div className="text-content text-center text-lg-start">
                            <h1 className="title-xl">The Art of <span className="text-base">Simplicity</span></h1>
                            <p className="des">Saint Cloud is the future of Bourbon, highlighting exceptional experiences through unique barrel selections and innovations.</p>
                            <Button>LEARN MORE</Button>
                        </div>
                    </div>
                    <div className="col-lg-6 text-end d-flex justify-content-center d-lg-block"> 
                        <div ref={HeroBottleWrap} className="hero-bottle d-inline-block"> 
                            <div ref={HeroBottle} className="bottle"><img src={heroBottleImg} alt="" /></div>
                        </div>
                    </div>
                </div> 
            </div> 
            <div className="hero-bg-logo w-100 overflow-hidden"><div ref={HeroBgLogo} className="bg-logo-wrap d-flex"><img src={heroBgLogo} alt="" /></div></div>
        </section>
    )
}
